const t = "https://help-center-service.care.vpsvc.com", e = "https://help-center-service.care-staging.vpsvc.com", n = (c = !1, r) => typeof window < "u" && window.location.port === "12345" ? {
  hcServiceUrl: e
} : {
  hcServiceUrl: c ? e : t
};
export {
  t as DEFAULT_SERVICE_URL,
  e as DEFAULT_SERVICE_URL_STAGING,
  n as getConfig
};
//# sourceMappingURL=help-center-knowledge-anatomies7.js.map
